"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderFooterCreatedModelChange = void 0;
var tslib_1 = require("tslib");
var change_base_1 = require("../change-base");
var enums_1 = require("../enums");
var HeaderFooterCreatedModelChange = (function (_super) {
    tslib_1.__extends(HeaderFooterCreatedModelChange, _super);
    function HeaderFooterCreatedModelChange(isHeader, headerFooterType, subDocumentInfo) {
        var _this = _super.call(this, subDocumentInfo.subDocumentId, 0, 1) || this;
        _this.isHeader = isHeader;
        _this.headerFooterType = headerFooterType;
        _this.subDocumentInfo = subDocumentInfo;
        _this.type = enums_1.ModelChangeType.HeaderFooterCreated;
        return _this;
    }
    return HeaderFooterCreatedModelChange;
}(change_base_1.ContentInsertedSubDocumentChange));
exports.HeaderFooterCreatedModelChange = HeaderFooterCreatedModelChange;
